import React from 'react'
import { Modal, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import CircularProgress from '@material-ui/core/CircularProgress';

export const CheckinSpinner = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <Modal 
      open={true} 
      className={classes.wrapper}
      disableEnforceFocus
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      >
      { <Paper className={classes.modal}>
            <>
                <Typography 
                  id="checkinpage-spinner-text"
                  variant="body1"
                >
                  {t('checkinpage.spinner.waiting')}
                </Typography>
                <CircularProgress
                    classes={{root: classes.wrapper}}
                    className="Spinner"
                    id="checkinpage-spinner-circle"
                    size={"50%"}
                />
            </>
        </Paper> }
    </Modal>
  )
}

const useStyles = makeStyles({
  wrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  modal: theme => ({
    border: '1px solid '+ theme.palette.primary.main,
    alignItems: 'center',
    justifyContent: 'center',
    width: "80%",
    height: '50%',
    maxHeight: '300px',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column'
  }),
  spinner: {
      height: '65%',
      width: '65%'
  }
})